import React from 'react';

interface IRadioButtonProps {
  name: string;
  index: number;
  id: string;
  checked: boolean;
  onChange: () => void;
  dataTestId?: string;
}

const RadioButton = ({
  name,
  index,
  id,
  checked,
  onChange,
  dataTestId,
}: IRadioButtonProps) => (
  <label
    key={`${index}-rolelabel-${id}`}
    htmlFor={id}
    className="prose-body-sm-reg block text-kira-slate-900"
  >
    <input
      key={`${index}-role-${id}`}
      name={`${index}-role`}
      id={id}
      type="radio"
      checked={checked}
      onChange={onChange}
      className="mr-2 h-4 w-4 border-2 border-kira-slate-700 checked:text-kira-blue-800 focus:ring-kira-blue-800"
      data-testid={dataTestId}
    />
    {name}
  </label>
);

export default RadioButton;
